export const topics = {
    'overall': 'Overall Score',
    'administrative_support': 'Administrative Support',
    'comfort': 'Comfort Expressing Ideas',
    'disruptive_conduct': 'Disruptive Conduct',
    'openness': 'Openness',
    'political_tolerance': 'Political Tolerance',
    'self_censorship': 'Self Censorship',
};
